const getters = {
  pageroute: (state) => state.common.pageroute,
  connect_instance: (state) => state.common.connect_instance,
  connect_alias: (state) => state.common.connect_alias,
  websocket_url: (state) => state.common.websocket_url,
  region: (state) => state.common.region,
  callLogs: (state) => state.common.callLogs,
  contactList: (state) => state.common.contactList,
  selectedLanguage: (state) => state.common.selectedLanguage,
  isTranscription: (state) => state.common.isTranscription,
  isTranslation: (state) => state.common.isTranslation,
  dialpadToggle: (state) => state.common.dialpadToggle,

  call_type: (state) => state.call.call_type,
  call_state: (state) => state.call.call_state,
  caller_name: (state) => state.call.caller_name,
  queue_name: (state) => state.call.queue_name,
  caller_number: (state) => state.call.caller_number,
  hold_status: (state) => state.call.hold_status,
  caller_id: (state) => state.call.caller_id,
  contact_attributes: (state) => state.call.contact_attributes,
  contact_id: (state) => state.call.contact_id,
  countryCode: (state) => state.call.countryCode,
  thirdPartyCountryCode: (state) => state.call.thirdPartyCountryCode,
  dialedNumber: (state) => state.call.dialedNumber,
  ivrNumber: (state) => state.call.ivrNumber,

  third_party_caller_name: (state) => state.call.third_party_caller_name,
  third_party_caller_number: (state) => state.call.third_party_caller_number,
  isPrimaryCallDisconnected:(state)=> state.call.isPrimaryCallDisconnected,
  third_party_hold_status: (state) => state.call.third_party_hold_status,
  on_destroyed_flag: (state) => state.call.on_destroyed_flag,
  start_time: (state) => state.call.start_time,
  end_time: (state) => state.call.end_time,
  callDuration: (state) => state.call.callDuration,
  displaySeconds: (state) => state.call.displaySeconds,
  displayMinutes: (state) => state.call.displayMinutes,
  displayHours: (state) => state.call.displayHours,
  onSetTimerFlag: (state) => state.call.onSetTimerFlag,
  on_outbound_flag: (state) => state.call.on_outbound_flag,
  fs_call_type: (state) => state.call.fs_call_type,
  on_connecting_flag: (state) => state.call.on_connecting_flag,
  notes_editor: (state) => state.call.notes_editor,
  number_pad: (state) => state.call.number_pad,
  lead_score: (state) => state.call.lead_score,
  loyalty_points: (state) => state.call.loyalty_points,
  call_log_flag: (state) => state.call.call_log_flag,
  external_id: (state) => state.call.external_id,
  call_type_name: (state) => state.call.call_type_name,
  freshchat_conversation_id: (state) => state.call.freshchat_conversation_id,
  freshchat_channel_id: (state) => state.call.freshchat_channel_id,
  freshchat_user_id: (state) => state.call.freshchat_user_id,
  freshchat_org_agent_id: (state) => state.call.freshchat_org_agent_id,
  freshchat_org_agent_name: (state) => state.call.freshchat_org_agent_name,
  freshchat_endcall_lock_flag: (state) =>
    state.call.freshchat_endcall_lock_flag,
  freshchat_pickedup_lock_flag: (state) =>
    state.call.freshchat_pickedup_lock_flag,
  freshchat_missed_lock_flag: (state) => state.call.freshchat_missed_lock_flag,
  freshchat_outboundcall_connected_lock:(state)=> state.call.freshchat_outboundcall_connected_lock,
  freshchat_connecting_lock_flag: (state) =>
    state.call.freshchat_connecting_lock_flag,
  freshchat_agent_id: (state) => state.call.freshchat_agent_id,
  freshchat_conversation_app_id: (state) =>
    state.call.freshchat_conversation_app_id,
  freshwork_crm_contact_id: (state) => state.call.freshwork_crm_contact_id,
  freshwork_crm_contact_mcr_id: (state) =>
    state.call.freshwork_crm_contact_mcr_id,
  freshchat_phone_topic_id: (state) => state.call.freshchat_phone_topic_id,

  chat_state: (state) => state.chat.chat_state,
  chat_name: (state) => state.chat.chat_name,
  chat_email: (state) => state.chat.chat_email,

  notes: (state) => state.notes.notes,
  editor: (state) => state.ticket.editor,
  selectedTicket: (state) => state.ticket.selectedTicket,
  ticketButtonStatus: (state) => state.ticket.ticketButtonStatus,
  noteButtonStatus: (state) => state.ticket.noteButtonStatus,

  mute_status: (state) => state.agent.mute_status,
  agent_name: (state) => state.agent.agent_name,
  agent_username: (state) => state.agent.agent_username,
  current_agent_state: (state) => state.agent.current_agent_state,
  agent_states: (state) => state.agent.agent_states,
  dialable_countries: (state) => state.agent.dialable_countries,
  quickconnects: (state) => state.agent.quickconnects,

  saveNumber: (state) => state.actions.saveNumber,
  homeSubNav: (state) => state.actions.homeSubNav,
  callSubNav: (state) => state.actions.callSubNav,
  outboundCall: (state) => state.actions.outboundCall,
  translationLang: (state) => state.actions.translationLang,
};
export default getters;
